import React from "react";
import { useSelector } from "react-redux";
import BoxShadow from "../../../Common/Components/BoxShadow";
import Edit from "../../../Common/Components/EditTimeTable";
import { useContract } from "../../../Admin/View/Items/Edit/EditTimeTable/Hooks";

const EditItem = ({ SelectMethod,isApp }) => {
  const { user: { item } } = useSelector(state => state);
  const {
    toggleSelect,
    arrLength,
    isInArray,
    loading,
    clearTimes,
    renderTimes,
    submit,
    submitRange
  } = useContract();

  if (item[0].timetabletype == "deactive") {
    return (
      <div className="col-12">
        <BoxShadow>
          <div className="row justify-content-center">
            <div className="col">
              <div>
                <h5>مدیر مجموعه عزیز</h5>
                <p>
                  مجموعه شما غیر فعال است در صورت نیاز با پشتیبانی تماس بگیرید.
                </p>
              </div>
            </div>
          </div>
        </BoxShadow>
      </div>
    );
  }
  return (
    <div>
      <Edit item_id={item[0].id}
        SelectMethod={SelectMethod}
        multi={{
          status: true,
          toggleSelect,
          arrLength,
          isInArray,
          clearTimes,
          renderTimes,
          submit,
          loading,
        }}
        range={{
          status: true,
          toggleSelect,
          arrLength,
          isInArray,
          clearTimes,
          renderTimes,
          submitRange,
          loading,
        }}
        isApp={isApp}
      />
    </div>
  );
};

export default EditItem;
